import React from 'react';
import { Box, BoxProps, CircularProgress } from '@mui/material';

import {
  type DevLoadingTraceDetails,
  toDevLoadingTraceKey,
  useDevLoadingTrace,
} from '@/utils/devLoadingTrace';

interface LoadingSpinnerProps
  extends Omit<BoxProps, 'display' | 'justifyContent' | 'alignItems'> {
  minHeight?: string;
  traceKey?: string;
  traceDetails?: DevLoadingTraceDetails;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  minHeight = '200px',
  traceKey,
  traceDetails,
  ...boxProps
}) => {
  useDevLoadingTrace(traceKey ?? 'shared.loading-spinner', true, {
    minHeight,
    component: 'LoadingSpinner',
    traceKey: traceKey ? toDevLoadingTraceKey(traceKey) : undefined,
    ...traceDetails,
  });

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight={minHeight}
      {...boxProps}
    >
      <CircularProgress />
    </Box>
  );
};

export default LoadingSpinner;
